<template>
  <div class="content-container">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <agentVendorShop @select="selectHandler" :showShop="false" />

      <el-form-item label="联系人">
        <el-input
          v-model="formInline.vendorContact"
          placeholder="请输入联系人"
        ></el-input>
      </el-form-item>
      <el-form-item label="联系手机">
        <el-input
          v-model="formInline.vendorMobile"
          placeholder="请输入联系手机"
        ></el-input>
      </el-form-item>
      <el-form-item label="所在城市">
        <el-select v-model="formInline.vendorCity" placeholder="请选择">
          <el-option
            v-for="(item, index) in CITY_ENUM"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="onSubmit"
          >查询</el-button
        >
        <el-button type="primary" icon="el-icon-plus" @click="onAdd"
          >新增</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-delete"
          @click="onBatchDelete"
          :disabled="multipleSelection.length === 0"
          >批量删除</el-button
        >
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <!-- <el-table-column prop="vendorid" label="商家ID"> </el-table-column> -->
      <el-table-column prop="vendorLoginAccount" label="登录名">
      </el-table-column>
      <el-table-column prop="vendorName" label="加盟商名"> </el-table-column>
      <el-table-column prop="vendorContact" label="联系人"> </el-table-column>
      <el-table-column prop="vendorMobile" label="联系手机"> </el-table-column>
      <el-table-column prop="vendorCity" label="所在城市"> </el-table-column>
      <el-table-column label="创建时间">
        <template slot-scope="scope">
          <div>{{ scope.row.createtime | formatDateTime }}</div>
        </template>
      </el-table-column>
      <el-table-column label="修改时间">
        <template slot-scope="scope">
          <div>{{ scope.row.modifiedtime | formatDateTime }}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="280">
        <template slot-scope="scope">
          <el-button type="text" @click="handleDelete(scope.row.vendorid)"
            >删除</el-button
          >
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
          <!-- <template v-show="this.userType == 'admin'"> -->
          <el-button type="text" @click="handleShop(scope.row.vendorid)"
            >查看门店</el-button
          >
          <el-button type="text" @click="handleStatistic(scope.row.vendorid)"
            >查看统计</el-button
          >

          <el-button type="text" @click="handleSubAccount(scope.row)"
            >子账号</el-button
          >

          <!-- </template> -->
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="page.currentPage"
      :page-size="page.pageSize"
      layout="total, prev, pager, next"
      :total="page.total"
    >
    </el-pagination>
    <EditDialog
      v-if="isDialogShow"
      @closeForm="closeForm"
      @handleUpdate="onSubmit"
      :isCreate="isCreate"
      :editInfo="editInfo"
    />


    <EditDialogSubAccount
      v-if="isSubaccountDialogShow"
      @closeForm="closeForm"
      :row="editInfo"
    />

  </div>
</template>

<script>
//import { mapGetters } from "vuex";
import agentVendorShop from "@/components/layout/agentVendorShop";

import enumObject from "../../plugins/enum";
import EditDialog from "./components/editDialog";
import EditDialogSubAccount from "./components/editDialogSubAccount";
export default {
  components: {
    EditDialog,
    EditDialogSubAccount,
    agentVendorShop
  },
  data() {
    return {
      formInline: {
        agentid: "",
        agentName: "",
        vendorid: "",
        vendorName: "",
        vendorContact: "",
        vendorMobile: "",
        vendorCity: ""
      },
      // vendorList: [],
      // agentList: [],
      tableData: [],
      agentListForPrompt: [],
      vendorListForPrompt: [],
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      multipleSelection: [],
      CITY_ENUM: enumObject.CITY_ENUM,
      isDialogShow: false,
      isSubaccountDialogShow: false,
      isCreate: true,
      editInfo: null
    };
  },

  methods: {
    selectHandler(x) {
      console.log("selectHandler", x);
      this.formInline.agentid = x.selectedAgent.agentid;
      this.formInline.vendorid = x.selectedVendor.vendorid;
      // this.formInline.machineInShopid = x.selectedShop.shopid;
    },
    onSubmit() {
      let queryModel = {
        agentid: this.formInline.agentid,
        vendorid: this.formInline.vendorid,
        vendorName: this.formInline.vendorName,
        vendorContact: this.formInline.vendorContact,
        vendorMobile: this.formInline.vendorMobile,
        vendorCity: this.formInline.vendorCity,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      };
      this.$axios(this.$urlMapping["查询加盟商"], {
        data: queryModel
      }).then(result => {
        this.tableData = result.data;
        this.page.total = result.totalCount;
        this.page.currentPage = result.pageNum;
      });
    },

    handleCurrentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.onSubmit();
    },
    onAdd() {
      this.editInfo = null;
      this.isCreate = true;
      this.isDialogShow = true;
    },
    handleDelete(vendorid) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let vendorIDs = [vendorid];
        this.$axios(this.$urlMapping["删除加盟商"], {
          data: {
            vendorIDs
          }
          // eslint-disable-next-line no-unused-vars
        }).then(result => {
          this.$notifySuccess();
          this.onSubmit();
        });
      });
    },
    handleEdit(editInfo) {
      this.editInfo = editInfo;
      this.isCreate = false;
      this.isDialogShow = true;
    },
    closeForm() {
      this.isDialogShow = false;
      this.isSubaccountDialogShow = false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onBatchDelete() {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let vendorIDs = this.multipleSelection.map(ele => ele.vendorid);
        this.$axios(this.$urlMapping["删除加盟商"], {
          data: {
            vendorIDs
          }
          // eslint-disable-next-line no-unused-vars
        }).then(result => {
          this.$notifySuccess();
          this.onSubmit();
        });
      });
    },
    handleShop(shopOwner) {
      this.$router.push({
        name: "shop",
        query: {
          shopOwner
        }
      });
    },
    handleStatistic(vendorid) {
      this.$router.push({
        name: "vendorOrderStatic",
        query: {
          vendorid
        }
      });
    },

    handleSubAccount(row) {     
      this.isSubaccountDialogShow=true;
      this.editInfo = row;

    }
  },
  mounted() {
    this.onSubmit();
  }
};
</script>

<style lang="less" scoped></style>
